import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import { isJson } from '../validators'

import Loading from './Loading'
import { FormattedMessage, useIntl } from 'react-intl'
import Subtitle from './Subtitle'
import { useDemoPayloads, usePostDemoPayload } from '../hooks/DemoPayloads'
import { requireAuthentication } from '../helpers/authentication'
import { Button, Typography, Select, Flex, Input, Form } from 'antd'

const { Link } = Typography
const { TextArea } = Input

const DemoPayloadPage = (props) => {
  const intl = useIntl()
  const authToken = useSelector((state) => state.user.data.token, shallowEqual)
  const { isLoading, payloads } = useDemoPayloads()
  const postDemoPayload = usePostDemoPayload()

  const [payloadTemplate, setPayloadTemplate] = React.useState(null)
  const [jsonText, setJsonText] = React.useState(null)
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    if (isLoading) return
    if (!availablePayloadOptions?.length > 0) return
    setPayloadTemplate(availablePayloadOptions[0].id)
    setJsonText(JSON.stringify(availablePayloadOptions[0].payload, null, 2))
  }, [availablePayloadOptions, isLoading])

  const availablePayloadOptions = payloads?.map((payload) => ({
    label: payload.name,
    value: payload.id,
    'data-testid': payload.name,
    ...payload,
  }))

  const submit = ({ payload }) => {
    postDemoPayload.mutate({
      payload: JSON.parse(payload),
      authToken,
    })
  }

  if (isLoading || !payloadTemplate) return <Loading />

  return (
    <>
      <div className="text-center header-relative">
        <h2>
          <FormattedMessage id="demoTracer.payloadTitle" />
        </h2>
        <Subtitle>
          <FormattedMessage id="demoTracer.payloadDescription" />
          <Link onClick={() => props.history.push('/reports')}>
            <FormattedMessage id="demoTracer.payloadDescriptionClickable" />
          </Link>
        </Subtitle>
      </div>
      <Flex vertical gap="middle" align="center">
        <Form
          name="payload"
          layout="vertical"
          autoComplete="off"
          style={{ width: '50%' }}
        >
          <Form.Item
            label={<FormattedMessage id="demoTracer.payloadLabel" />}
            rules={[{ required: true }]}
          >
            <Select
              name="select"
              data-testid="select-payload"
              value={payloadTemplate}
              onSelect={(value, option) => {
                setError(null)
                setPayloadTemplate(value)
                setJsonText(JSON.stringify(option.payload, null, 2))
              }}
              options={availablePayloadOptions}
            />
          </Form.Item>
          <Form.Item validateStatus={error ? 'error' : null} help={error}>
            <TextArea
              defaultValue={jsonText}
              value={jsonText}
              rows={20}
              rules={[{ required: true }]}
              onChange={(e) => {
                setJsonText(e.target.value)
                const validationError = isJson(e.target.value)
                validationError ? setError(validationError) : setError(null)
              }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              onClick={() => submit({ payload: jsonText })}
              loading={postDemoPayload.isLoading}
              disabled={error}
            >
              {intl.formatMessage({ id: 'forms.submit' })}
            </Button>
          </Form.Item>
        </Form>
      </Flex>
    </>
  )
}

export default requireAuthentication(DemoPayloadPage, 'page-demo:get')
